import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import API from "../config/api";
import "../css/Offerte.css";

const Offerte = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch offers from backend PHP API
    const fetchOffers = async () => {
      try {
        setLoading(true);
        const response = await fetch(API.ENDPOINTS.OFFERS);
        const data = await response.json();

        // Use backend order (do not sort here) so admin ordering is preserved
        setOffers(data || []);
        setError(null);
      } catch (err) {
        console.error("Error fetching offers:", err);
        setError("Impossibile caricare le offerte. Riprova più tardi.");
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  return (
    <div className="offerte-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="offerte-hero-compact">
        <div className="offerte-hero-content-compact">
          <span className="section-subtitle">PROMOZIONI</span>
          <h1 className="offerte-hero-title-compact">Offerte</h1>
          <p className="offerte-hero-slogan-compact">
            Scopri le nostre migliori offerte su prodotti selezionati
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="offerte-content-section">
        <div className="offerte-container">

        {loading && (
          <div className="loading-message">
            <div className="spinner"></div>
            <p>Caricamento in corso...</p>
          </div>
        )}

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && offers.length === 0 && (
          <div className="empty-message">
            <p>Nessuna offerta disponibile al momento.</p>
          </div>
        )}

        {!loading && !error && offers.length > 0 && (
          <div className="offers-grid">
            {offers.map((item) => {
              const buildContactLink = (it) => {
                const base = "/contatti";
                const msg = `Richiesta informazioni per: ${it.title}`;
                return `${base}?message=${encodeURIComponent(msg)}`;
              };

              const formatPrezzo = (p) => {
                if (p === null || p === undefined || p === "") return "";
                if (typeof p === "number") return `€ ${p}`;
                if (/[€£$]/.test(p) || /[^0-9.,\s]/.test(p)) return p;
                return `€ ${p}`;
              };

              return (
                <article key={item.id} className="offer-card card">
                  {item.hasImage &&
                    item.imagePath &&
                    // if admin provided positioning/scale use background preview
                    (typeof item.imagePosX === "number" &&
                    typeof item.imagePosY === "number" &&
                    typeof item.imageScale === "number" ? (
                      <div
                        className="offer-image"
                        role="img"
                        aria-label={item.title}
                        style={{
                          backgroundImage: `url(${item.imagePath})`,
                          backgroundPosition: `${Math.round(
                            item.imagePosX
                          )}px ${Math.round(item.imagePosY)}px`,
                          backgroundSize: `${item.imageScale * 100}% auto`,
                        }}
                      />
                    ) : (
                      <div className="offer-image">
                        <img src={item.imagePath} alt={item.title} />
                      </div>
                    ))}

                  <div className="offer-content">
                    <h2>{item.title}</h2>
                    <p className="offer-description">{item.description}</p>
                    <div className="offer-price">
                      {formatPrezzo(item.prezzo)}
                    </div>

                    <div className="offer-action">
                      <a
                        href={buildContactLink(item)}
                        className="btn btn--primary"
                      >
                        Richiedi preventivo
                      </a>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}
        </div>
      </section>
    </div>
  );
};

export default Offerte;
